"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Snippets = require("snippets");
var PolicyTemplate = /** @class */ (function (_super) {
    __extends(PolicyTemplate, _super);
    function PolicyTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolicyTemplate.prototype.render = function () {
        var policy = this.props.data.policy;
        return policy && policy.handle ? (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.Container, { className: "flex items-start justify-between mt-2-1", tag: "section" },
                React.createElement("div", { className: "hidden lg:block w-1/4" },
                    React.createElement(Snippets.Breadcrumbs, __assign({}, this.props))),
                React.createElement("div", { className: "w-full lg:w-1/2 text-center" },
                    React.createElement(Snippets.Heading, { size: "h4", tag: "h1", className: "font-bold leading-normal" }, policy.title)),
                React.createElement("div", { className: "hidden lg:block w-1/4" })),
            React.createElement(Snippets.Container, { width: "xs", className: "py-3-2 md:py-6-4" },
                React.createElement(Snippets.RichText, null, policy.content)))) : null;
    };
    return PolicyTemplate;
}(React.Component));
exports.PolicyTemplate = PolicyTemplate;
